import React from 'react';
import { isMobileOnly } from 'react-device-detect';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import ActionButton from '../buttons/ActionButton';

const StoreModal = ({ content: { title, body }, type, onClick }) => {
  const device = isMobileOnly ? 'mobile' : 'desktop';
  return (
    <div className='modal'>
      <div className={classnames('modal-content-wrapper', device)}>
        <div className={classnames('modal-content', device)}>
          <div className={classnames('modal-header')}>
            <div className={classnames('modal-type', type)}/>
            <div className='modal-title'>{title}</div>
          </div>
          <div className={classnames('modal-body', device)}>{body}</div>
          <div className='modal-footer'>
            <ActionButton text='OK' width='normal' onClick={onClick} />
          </div>
        </div>
      </div>
    </div>
  );
};

StoreModal.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired
  }),
  type: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

export default StoreModal;
